import axios from "axios";

import {
  authDeviceWithDomainHeader,
  authWithDomainHeader,
} from "../authServices/auth.header";
import { setRingGroup } from "@/helpers/BatchService.js";

const API_URL = process.env.VUE_APP_ROOT_API;
class RingGroupService {
  // Get Ring Group List
  async getRingGroupList() {
    return await axios
      .get(API_URL + `call-app/ring-group`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Add Ring Group
  async AddRingItem(data) {
    return await axios
      .post(API_URL + `call-app/ring-group`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setRingGroup();
        return response.data;
      });
  }

  // Get Ring Group Item
  async getRingItem(ring_group_uuid, domain_uuid = null) {
    return await axios
      .get(API_URL + `call-app/ring-group/${ring_group_uuid}`, {
        headers: domain_uuid
          ? authWithDomainHeader(domain_uuid)
          : authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Edit Ring Group Item
  async updateRingItem(ring_group_uuid, data) {
    return await axios
      .put(API_URL + `call-app/ring-group/${ring_group_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setRingGroup();
        return response.data;
      });
  }
  // Edit Ring Group Item
  async updateRingItemStatus(ring_group_uuid, data) {
    return await axios
      .patch(API_URL + `call-app/ring-group/${ring_group_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //delete Ring Group Item
  async deleteRingItem(ring_group_uuid) {
    return await axios
      .delete(API_URL + `call-app/ring-group/${ring_group_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setRingGroup();
        return response.data;
      });
  }
}

export default new RingGroupService();
